define((require) => {
    "use strict";

    const Class                   = require("shared/util/Class");
    const $                       = require("jquery");
    const _                       = require("underscore");
    const MathUtil                = require("shared/util/MathUtil").default;
    const Matrix                  = require("shared/vendor/Matrix");

    const DEFAULT_MOVE_VALUE = 20;

    return Class.extend({

        _canvas:                null,
        _widgetRect:            null,
        _animationModel:        null,
        _experienceModel:       null,
        _widgetMatrix:          null,
        _representationMatrix:  null,
        _widgetSize: {
            width: null,
            height: null
        },

        _ui: {
            box: $("<div>", {"class": "move-animation-representation"}),
            arrow: $("<div>", {"class": "move-animation-arrow"})
        },

        _insertDefaultValues: function() {
            var currentTop = this._animationModel.get("verticalMove"),
                currentLeft = this._animationModel.get("horizontalMove"),
                position;

            if (currentTop === null || currentLeft === null) {
                position = this._experienceModel.getPercentagePosition({
                    top: DEFAULT_MOVE_VALUE,
                    left: DEFAULT_MOVE_VALUE
                });

                this._animationModel.set({
                    verticalMove: position.top,
                    horizontalMove: position.left
                });
            }
        },

        _getCssFromMatrix: function() {
            // Clone the size of the widget
            var css = _.clone(this._widgetSize);

            // Add the matrix to the clone
            css.transform = this._representationMatrix.toString();
            return css;
        },

        _updateWidgetMatrixAndSize: function() {
            // Object with width, height, left, top, rotation
            var widgetRect = this._widgetView.getRect(),
                rect = {
                    left: widgetRect.x,
                    top: widgetRect.y,
                    width: widgetRect.width,
                    height: widgetRect.height,
                    rotation: this._widgetModel.get("rotation")
                };

            // Build new matrix
            this._widgetMatrix = new Matrix();
            this._widgetMatrix.translate(rect.left, rect.top);
            this._widgetMatrix.rotateCenter(rect.rotation * Math.PI / 180);

            // Build size object (matrix doesn't contain size of element)
            this._widgetSize = {
                width:  rect.width,
                height: rect.height
            };
        },

        _updateRepresentationMatrix: function() {
            var position = this._experienceModel.getPixelPosition({
                left: this._animationModel.get("horizontalMove"),
                top: this._animationModel.get("verticalMove")
            });

            // Should not be needed
            if (!this._widgetMatrix) {
                return;
            }

            // Create new temporary matrix based on the widget matrix
            this._representationMatrix = this._widgetMatrix.clone();

            // Offset the new matrix
            this._representationMatrix.translate(position.left, position.top);
        },

        _getArrowCss: function() {
            var p1    = this._getCenterFromMatrix(this._widgetMatrix),
                p2    = this._getCenterFromMatrix(this._representationMatrix),
                width = MathUtil.getDistance(p1, p2),
                angle = MathUtil.getAngle(p1, p2),
                arrowCss = {
                    width: width,
                    left: p1.left,
                    top: p1.top,
                    transform: `rotate(${angle}deg)`
                };

            return arrowCss;
        },

        // Returns the center coordinate of (rotated) widget or representation
        _getCenterFromMatrix: function(matrix) {
            // Top left corner of element
            var corner = {
                    x: matrix.x,
                    y: matrix.y
                },
                degrees = this._representationMatrix.getRotation(),
                // Center that ignores rotation of element
                center = {
                    x: corner.x + this._ui.box.width() / 2,
                    y: corner.y + this._ui.box.height() / 2
                },
                rotatedCenter = MathUtil.rotatePoint(center, corner, degrees);

            return {
                left: rotatedCenter.x,
                top:  rotatedCenter.y
            };
        },

        constructor: function(experienceModel, widgetView, animationModel) {
            this._canvas            = widgetView.getParentContainer();
            this._animationModel    = animationModel;
            this._widgetView        = widgetView;
            this._widgetModel       = widgetView.model;
            this._experienceModel   = experienceModel;

            this._insertDefaultValues();
        },

        addRepresentationToDom: function() {
            this._updateWidgetMatrixAndSize();
            this._canvas.append(this._ui.box, this._ui.arrow);
            this.moveRepresentation();
        },

        removeRepresentationToDom: function() {
            this._ui.box.remove();
            this._ui.arrow.remove();
        },

        moveRepresentation: function() {
            this._updateRepresentationMatrix();
            if (this._representationMatrix) {
                this._ui.box.css(this._getCssFromMatrix());
                this._ui.arrow.css(this._getArrowCss());
            }
        }
    }, {
        DEFAULT_MOVE_VALUE: DEFAULT_MOVE_VALUE
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/move/MoveAnimationRepresentation.js